var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlias({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35355 10.3536C7.15829 10.5488 6.84171 10.5488 6.64645 10.3536C6.45118 10.1583 6.45118 9.84171 6.64645 9.64645L7.35355 10.3536ZM11 6L11.3536 5.64645C11.4473 5.74022 11.5 5.86739 11.5 6C11.5 6.13261 11.4473 6.25979 11.3536 6.35355L11 6ZM6.64645 2.35355C6.45118 2.15829 6.45118 1.84171 6.64645 1.64645C6.84171 1.45118 7.15829 1.45118 7.35355 1.64645L6.64645 2.35355ZM1 6.5C0.723858 6.5 0.5 6.27614 0.5 6C0.5 5.72386 0.723858 5.5 1 5.5V6.5ZM6.64645 9.64645L10.6464 5.64645L11.3536 6.35355L7.35355 10.3536L6.64645 9.64645ZM10.6464 6.35355L6.64645 2.35355L7.35355 1.64645L11.3536 5.64645L10.6464 6.35355ZM1 5.5H11V6.5H1V5.5Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlias);
export default __webpack_public_path__ + "static/media/alias.2b5deece.svg";
export { ForwardRef as ReactComponent };